import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (pw.length < 6) { toast.error("Yeni şifre en az 6 karakter olmalı"); return; }
    if (pw !== pw2) { toast.error("Şifreler eşleşmiyor"); return; }
    setLoading(true);
    try {
      await api.resetPassword(token, pw);
      toast.success("Şifreniz güncellendi, giriş yapabilirsiniz");
      navigate("/login", { replace: true });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Sıfırlama başarısız");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="relative w-full max-w-md">
        <Link to="/login" className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="h-4 w-4" /> Girişe dön</Link>
        <div className="rounded-2xl border border-border bg-card p-8 shadow-2xl">
          <h1 className="mb-1 font-display text-2xl font-bold">Yeni Şifre Belirle</h1>
          <p className="mb-6 text-sm text-muted-foreground">Hesabınız için yeni bir şifre girin.</p>
          {!token ? (
            <div className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-sm text-rose-400">Geçersiz bağlantı — token bulunamadı.</div>
          ) : (
            <div className="space-y-4">
              <div><Label>Yeni Şifre</Label>
                <div className="relative mt-1.5"><Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" /><Input data-testid="rp-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="pl-9" /></div>
              </div>
              <div><Label>Yeni Şifre (Tekrar)</Label><Input data-testid="rp-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5" /></div>
              <Button data-testid="rp-submit" onClick={submit} disabled={loading} className="w-full">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Şifreyi Güncelle"}</Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
